<div
  class="tableList"
  [class.scrollbarXonly]="scrollX() && !scrollY()"
  [class.scrollbarYonly]="scrollY() && !scrollX()"
  [class.scrollbarXY]="scrollX() && scrollY()"
>
  @if (table()) {
    <table class="table table-striped">
      <thead>
        <tr>
          @if (showActionButtons()) {
            <th colspan="2" class="text-center">Actions</th>
          }
          @if (showModalButton()) {
            <th class="text-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                class="bi bi-box-arrow-up-right"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                />
                <path
                  fill-rule="evenodd"
                  d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
                />
              </svg>
            </th>
          }
          @for (col of table().columnSettings; track col) {
            @if (col.display) {
              <th class="ps-5 text-left">{{ col.text | titlecase }}</th>
            }
          }
        </tr>
      </thead>
      <tbody>
        @for (dataRow of tableDisplay; track dataRow; let i = $index) {
          <ng-container #dataRows>
            <tr
              [id]="dataRow[table().primaryKey]"
              [class.deleted-row]="dataRow['isDeleted']"
            >
              @if (showActionButtons()) {
                <td class="pe-0" style="width: 50px">
                  @if (bEditId !== dataRow[table().primaryKey]) {
                    <button
                      [disabled]="bEditId !== null"
                      class="d-inline btn btn-sm btn-info m-0"
                      style="height: 32px"
                      (click)="onEdit(dataRow[table().primaryKey])"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-pencil-square"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                        />
                      </svg>
                    </button>
                  }
                  @if (bEditId === dataRow[table().primaryKey]) {
                    <button
                      style="height: 32px"
                      class="d-inline btn btn-sm btn-primary m-0 align-self-center"
                      type="submit"
                      (click)="onSave(dataRow[table().primaryKey])"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-check2-square"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"
                        />
                        <path
                          d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"
                        />
                      </svg>
                    </button>
                  }
                </td>
                <td style="width: 50px">
                  @if (bEditId === dataRow[table().primaryKey]) {
                    <button
                      style="height: 32px"
                      class="d-inline btn btn-sm btn-danger m-0 align-self-center"
                      type="button"
                      (click)="onCancel()"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-x-square"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                        />
                        <path
                          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                        />
                      </svg>
                    </button>
                  }
                  @if (bEditId !== dataRow[table().primaryKey]) {
                    @if (dataRow['isDeleted']) {
                      <button
                        [disabled]="bEditId !== null"
                        class="d-inline btn btn-sm btn-success"
                        title="Restore"
                        (click)="onRestore(dataRow[table().primaryKey])"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-arrow-counterclockwise"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"
                          />
                          <path
                            d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"
                          />
                        </svg>
                      </button>
                    } @else {
                      <button
                        [disabled]="bEditId !== null"
                        class="d-inline btn btn-sm btn-danger"
                        (click)="onDelete(dataRow[table().primaryKey])"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                          />
                          <path
                            fill-rule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                          />
                        </svg>
                      </button>
                    }
                  }
                </td>
              }
              @if (showModalButton()) {
                <td style="width: 50px">
                  <button
                    style="height: 32px"
                    class="d-inline btn btn-sm btn-info m-0 align-self-center"
                    type="button"
                    (click)="onShowModal(dataRow[table().primaryKey])"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-window-stack"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M4.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM6 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                      />
                      <path
                        d="M12 1a2 2 0 0 1 2 2 2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2 2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10ZM2 12V5a2 2 0 0 1 2-2h9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1Zm1-4v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8H3Zm12-1V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2h12Z"
                      />
                    </svg>
                  </button>
                </td>
              }
              @for (prop of dataRow | keyvalue: originalOrder; track prop) {
                @for (map of table().columnSettings; track map) {
                  @if (prop.key) {
                    @if (map.mapDataCol === prop.key && map.display) {
                      @if (bEditId !== dataRow[table().primaryKey]) {
                        <td class="ps-5 text-left">
                          {{ prop.value }}
                        </td>
                      }
                      @if (bEditId === dataRow[table().primaryKey]) {
                        <td [id]="prop.key" class="ps-5 text-left">
                          <input
                            #dataInput
                            type="text"
                            value="{{ prop.value }}"
                          />
                        </td>
                      }
                    }
                  }
                }
              }
            </tr>
          </ng-container>
        }
      </tbody>
    </table>
  }
</div>

@if (showFooter() && table()) {
  <div class="tablePageContainer">
    <ngb-pagination
      class="tablePage"
      [boundaryLinks]="table().data.length / pageSize > maxSize"
      [maxSize]="maxSize"
      [collectionSize]="table().data.length"
      [(page)]="page"
      [pageSize]="pageSize"
      (pageChange)="updatePageCollection($event)"
    ></ngb-pagination>
    <div ngbDropdown class="tablePageDD">
      <button class="btn btn-outline-primary" id="ddPage" ngbDropdownToggle>
        {{ pageSize }} items per page
      </button>
      <div ngbDropdownMenu aria-labelledby="ddPage">
        <button ngbDropdownItem (click)="pSize = 10">10 items per page</button>
        <button ngbDropdownItem (click)="pSize = 20">20 items per page</button>
        <button ngbDropdownItem (click)="pSize = 50">50 items per page</button>
        <button ngbDropdownItem (click)="pSize = 100">
          100 items per page
        </button>
      </div>
    </div>
  </div>
}
